import "devextreme/data/odata/store";
import notify from 'devextreme/ui/notify';
import moment from 'moment'
import {
  DxButton
} from 'devextreme-vue';
import {
  DxDateBox
} from 'devextreme-vue/date-box';
import {
  DxTextBox
} from 'devextreme-vue/text-box';
import {
  DxSelectBox
} from 'devextreme-vue/select-box';
import DxDataGrid, {
  DxColumn,
  DxLoadPanel,
  DxEditing,
  DxLookup,
  DxRequiredRule
} from "devextreme-vue/data-grid";
import {
  DxBox,
  DxItem
} from 'devextreme-vue/box';

import {
  shiftResultService
} from '../../../services/shift-result.service';

import {
  masterService
} from '../../../services/master.service';

export default {
  components: {
    DxButton,
    DxDateBox,
    DxTextBox,
    DxSelectBox,
    DxColumn,
    DxLoadPanel,
    DxDataGrid,
    DxBox,
    DxItem,
    DxEditing,
    DxLookup,
    DxRequiredRule
  },
  data() {
    return {
      loading: true,
      error: false,
      success: false,
      workingDay: moment(),
      currentWorkerShift: {},
      currentShiftText: "",
      workNumbers: [],
      selectWorkNumberId: null,
      workerNumberDateTimes: [],
      selectWorkNumberDateTime: null,
      currentWorkTimeSheet: {
        timeSheetWorkNumbers: []
      },
      focusedRowKey: null,
      selectedRowKeys: [],
      originalTimeSheetWorkNumbers: [],
      dataGridInstance: null,
      submitCellError: false
    };
  },
  methods: {
    fetchWorkTimeSheetData() {

      let self = this;

      masterService.getWorkerNumbers(this.$store.state.worker.locationId)
        .then((success) => {
          if (success.messageType == 1) {
            self.workNumbers = success.content.workNumbers;
          } else {
            self.showMessage(success.message, 'error');
          }
        }).catch((errors) => {
          console.log(errors);
        })

      this.workingDay = moment(this.$route.params.workingDay).format("YYYY-MM-DD");

      shiftResultService.getWorkTimeSheet(this.workingDay)
        .then((success) => {
          if (success.messageType == 1) {

            let workerTimeSheet = success.content

            self.currentWorkTimeSheet = workerTimeSheet;
            self.currentShiftText = self.currentWorkTimeSheet.shiftText;

            self.getWorkerNumberDateTime(self);
            self.LoadingDataGridData(self);

            self.originalTimeSheetWorkNumbers = self.copyArr(workerTimeSheet.timeSheetWorkNumbers);

          } else {
            self.showMessage(success.message, 'error');
            self.onClickToBackShiftAdjust(null, self, 3);
          }

          self.loading = false;
          self.error = false;
          self.success = true;

        }).catch((errors) => {

          console.log(errors);

          self.loading = false;
          self.error = true;
          self.success = false;
        })
    },
    getWorkerNumberDateTime(self) {

      self.workerNumberDateTimes = [];

      let startTime = moment(self.currentWorkTimeSheet.workIn).add(-Number(self.$store.state.constantMaxOverTime), 'hours');
      let endTime = moment(self.currentWorkTimeSheet.workOut).add(self.$store.state.constantMaxOverTime, 'hours');

      for (let dateTime = startTime; dateTime <= endTime; dateTime.add(self.$store.state.constantWorksheetTimeUnit, 'minutes')) {
        self.workerNumberDateTimes.push({
          "dateTime": moment(dateTime).format("YYYY-MM-DDTHH:mm:ss"),
          "showText": moment(dateTime).format("DD日 HH:mm")
        });
      }
    },
    copyArr(arr) {
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i]);
      }
      return res;
    },
    copy(obj1, obj2) {
      obj2 = obj2 || {};
      for (var name in obj1) {
        if (typeof obj1[name] === "object") {
          obj2[name] = (Array.isArray(obj1[name])) ? [] : {};
          this.copy(obj1[name], obj2[name]);
        } else {
          obj2[name] = obj1[name];
        }
      }
      return obj2;
    },
    LoadingDataGridData(self) {

      self.currentWorkTimeSheet.timeSheetWorkNumbers.sort(self.sortTimeSheetWorkNumber);

      let orderNumber = 1;

      for (let timeSheetWorkNumber of self.currentWorkTimeSheet.timeSheetWorkNumbers) {
        timeSheetWorkNumber.orderNumber = orderNumber;
        orderNumber++;
      }

      for (let timeSheetWorkNumber of self.currentWorkTimeSheet.timeSheetWorkNumbers) {
        for (let _timeSheetWorkNumber of self.currentWorkTimeSheet.timeSheetWorkNumbers) {
          if (timeSheetWorkNumber.orderNumber == _timeSheetWorkNumber.orderNumber - 1) {
            timeSheetWorkNumber.workEnd = _timeSheetWorkNumber.workStart;
            if (timeSheetWorkNumber._State_ != 2) timeSheetWorkNumber._State_ = 4;
          }
        }
      }
    },
    sortTimeSheetWorkNumber(a, b) {
      return moment(a.workStart) - moment(b.workStart);
    },
    onClickDelete() {

      // 削除できるかどうか
      if (this.focusedRowKey == null) {
        this.showMessage(process.env.VUE_APP_BASE_MESSAGE_SELECT_ROW, 'error');
        return;
      }

      let _tempTimeSheetWorkNumbers = [];
      for (let timeSheetWorkNumber of this.currentWorkTimeSheet.timeSheetWorkNumbers) {
        if (timeSheetWorkNumber.orderNumber != this.focusedRowKey) {
          _tempTimeSheetWorkNumbers.push(timeSheetWorkNumber);
        }
        if (timeSheetWorkNumber.orderNumber == this.focusedRowKey && timeSheetWorkNumber.id == -1 && timeSheetWorkNumber.workNumberId == -1) {
          this.showMessage(process.env.VUE_APP_BASE_MESSAGE_LAST_CAN_NOT_DELETE, 'error');
          return;
        }
      }

      this.currentWorkTimeSheet.timeSheetWorkNumbers = [];

      this.currentWorkTimeSheet.timeSheetWorkNumbers = _tempTimeSheetWorkNumbers;

      this.LoadingDataGridData(this);

      this.focusedRowKey = null;
      this.selectedRowKeys = [];
    },
    onClickApply() {

      // 適用できるかどうか
      if (this.selectWorkNumberId == null) {
        this.showMessage(process.env.VUE_APP_BASE_MESSAGE_SELECT_WORK_NUMBER, 'error');
        return;
      }
      if (this.selectWorkNumberDateTime == null) {
        this.showMessage(process.env.VUE_APP_BASE_MESSAGE_SELECT_WORK_NUMBER_START_DATETIME, 'error');
        return;
      }

      // 同じ業務の時間と終業の業務内容は重複追加できない
      for (let timeSheetWorkNumber of this.currentWorkTimeSheet.timeSheetWorkNumbers) {
        if (this.selectWorkNumberDateTime == timeSheetWorkNumber.workStart) {
          this.showMessage(process.env.VUE_APP_BASE_MESSAGE_REPEAT_WORK_NUMBER_START_DATETIME, 'error');
          return;
        }
      }

      let workNumberName = "";
      for (let workNumber of this.workNumbers) {
        if (workNumber.workNumberId == this.selectWorkNumberId) {
          workNumberName = workNumber.workNumberName;
          break;
        }
      }

      let addTimeSheetWorkNumber = {
        "orderNumber": 1,
        "workNumberName": workNumberName,
        "workStartDayTime": moment(this.selectWorkNumberDateTime).format("DD日 HH:mm"),
        "id": -1,
        "workerTimeSheetId": this.currentWorkTimeSheet.id,
        "workNumberId": this.selectWorkNumberId,
        "workStart": this.selectWorkNumberDateTime,
        "workEnd": this.selectWorkNumberDateTime,
        "rowVersion": "",
        "_State_": 2
      };

      this.currentWorkTimeSheet.timeSheetWorkNumbers.push(addTimeSheetWorkNumber);

      this.LoadingDataGridData(this);

      this.focusedRowKey = null;
      this.selectedRowKeys = [];
    },
    onRowUpdating(e) {
      if (e.newData != null) {

        for (let timeSheetWorkNumber of this.currentWorkTimeSheet.timeSheetWorkNumbers) {
          // 現在変更行の変更後時間、同じ時間存在している行の場合、エラーメッセージを出力
          if (e.key != timeSheetWorkNumber.orderNumber && timeSheetWorkNumber.workStart == e.newData.workStart) {
            this.showMessage(process.env.VUE_APP_BASE_MESSAGE_REPEAT_WORK_NUMBER_START_DATETIME, 'error');
            e.cancel = true;

            // 提出ボタンクリック時に当イベントで発生するエラーを検知するためフラグを設定する
            this.submitCellError = true;
            return;
          }
        }

        for (let timeSheetWorkNumber of this.currentWorkTimeSheet.timeSheetWorkNumbers) {
          // 新規作成行以外、編集_State_にセットする
          if (e.key == timeSheetWorkNumber.orderNumber) {
            if(timeSheetWorkNumber.id != -1){
              timeSheetWorkNumber._State_ = 4
            }
            break;
          }
        }

      }
    },
    onRowUpdated() {
      this.LoadingDataGridData(this);
    },
    onSelectionChanged({
      selectedRowsData
    }) {

      this.focusedRowKey = null

      if (selectedRowsData.length > 0)
        this.focusedRowKey = selectedRowsData[0] && selectedRowsData[0].orderNumber;
    },
    saveGridInstance: function(e) {
      this.dataGridInstance = e.component;
    },
    onClickToSubmitWorkerTimeSheet: function() {

      // セル編集中の場合に発生するonRowUpdatingイベントのエラーを検知するためフラグを初期化する
      this.submitCellError = false;

      // 編集中のセルのデータを保存する
      this.dataGridInstance.saveEditData()
        .then(() => {

        // onRowUpdatingでエラーが発生した場合、処理を終了する
        if (this.submitCellError == true) return;

        // ワークシートが提出できない場合
        if (this.currentWorkTimeSheet.timeSheetWorkNumbers.length <= 1) {
          this.showMessage(process.env.VUE_APP_BASE_MESSAGE_PLEASE_EDIT_WORK_NUMBER, 'error');
          return;
        }

        let minWorkerNumberStart = this.currentWorkTimeSheet.timeSheetWorkNumbers[0].workStart;
        let maxWorkerNumberStart = this.currentWorkTimeSheet.timeSheetWorkNumbers[this.currentWorkTimeSheet.timeSheetWorkNumbers.length - 1].workStart;

        for (let timeSheetWorkNumber of this.currentWorkTimeSheet.timeSheetWorkNumbers) {

          if (timeSheetWorkNumber.workNumberId == -1 && timeSheetWorkNumber.id == -1) {

            if (moment(timeSheetWorkNumber.workStart).format() != moment(maxWorkerNumberStart).format()) {
              this.showMessage(process.env.VUE_APP_BASE_MESSAGE_LAST_TIME_NOT_MAX, 'error');
              return;
            }
          }
        }
        let workerTimeSheet = {};

        workerTimeSheet = this.copy(this.currentWorkTimeSheet, workerTimeSheet);

        workerTimeSheet.workStart = minWorkerNumberStart;
        workerTimeSheet.workEnd = maxWorkerNumberStart;

        switch (workerTimeSheet._State_) {
          case 1:
            workerTimeSheet._State_ = 4;
            break;
          case 2:
            workerTimeSheet._State_ = 2;
            break;
        }

        if (JSON.stringify(workerTimeSheet.lunchStart) == "{}") workerTimeSheet.lunchStart = null
        if (JSON.stringify(workerTimeSheet.lunchEnd) == "{}") workerTimeSheet.lunchEnd = null
        if (JSON.stringify(workerTimeSheet.overtime) == "{}") workerTimeSheet.overtime = null

        if (JSON.stringify(workerTimeSheet.worksheetEntryStatu.entryStatusId) == "{}") workerTimeSheet.worksheetEntryStatu.entryStatusId = null

        workerTimeSheet.worksheetEntryStatu.entryTypeId = 1;

        if (JSON.stringify(workerTimeSheet.worksheetEntryStatu.createdUserId) == "{}") workerTimeSheet.worksheetEntryStatu.createdUserId = null;
        if (JSON.stringify(workerTimeSheet.worksheetEntryStatu.createdAt) == "{}") workerTimeSheet.worksheetEntryStatu.createdAt = null;
        if (JSON.stringify(workerTimeSheet.worksheetEntryStatu.updatedUserId) == "{}") workerTimeSheet.worksheetEntryStatu.updatedUserId = null;
        if (JSON.stringify(workerTimeSheet.worksheetEntryStatu.updatedAt) == "{}") workerTimeSheet.worksheetEntryStatu.updatedAt = null;
        if (JSON.stringify(workerTimeSheet.worksheetEntryStatu.updatedProgramId) == "{}") workerTimeSheet.worksheetEntryStatu.updatedProgramId = null;

        workerTimeSheet.worksheetEntryStatu._State_ = 4;

        let numAdd = -1;
        let _timeSheetWorkNumbers = [];
        for (let timeSheetWorkNumber of workerTimeSheet.timeSheetWorkNumbers) {
          if (timeSheetWorkNumber.id == -1 && timeSheetWorkNumber.workNumberId == -1) {
            continue;
          }
          if (timeSheetWorkNumber.id == -1) {
            timeSheetWorkNumber.id = numAdd;
            numAdd--;
          }
          _timeSheetWorkNumbers.push(timeSheetWorkNumber);
        }

        workerTimeSheet.timeSheetWorkNumbers = _timeSheetWorkNumbers;

        for (let originalTimeSheetWorkNumber of this.originalTimeSheetWorkNumbers) {

          let isDelete = true;

          for (let timeSheetWorkNumber of workerTimeSheet.timeSheetWorkNumbers) {
            if (originalTimeSheetWorkNumber.id == timeSheetWorkNumber.id) {
              isDelete = false;
              break;
            }
          }

          if (isDelete) {
            originalTimeSheetWorkNumber._State_ = 8;
            workerTimeSheet.timeSheetWorkNumbers.push(originalTimeSheetWorkNumber);
          }

        }

        // APIを呼び出す
        let self = this

        shiftResultService.updateWorkTimeSheet(workerTimeSheet, this.$store.state.constantClosingTime)
          .then(
            success => {
              if (success.messageType == 1) {
                self.showMessage(success.message, 'success');

                self.onClickToBackShiftAdjust(null, self, 2)
              } else {
                self.showMessage(success.message, 'error');
              }
            },
            error => {
              console.log(error)
            }
          );
        })
    },
    onClickToBackShiftAdjust(e, self, type = 1) {
      if (e != null) self = this

      self.$store.commit({
        type: 'setShiftAdjustAllWorkerShiftsByWorkingDay',
        workingDay: self.workingDay,
        editType: type
      });

      if (self.$store.state.fromUrlName != null && self.$store.state.fromUrlName != "") {
        self.$router.push({
          name: self.$store.state.fromUrlName
        });
      } else {
        self.$router.push({
          name: 'shift-adjustment'
        });
      }
    },
    showMessage(text, type) {
      notify({
        message: text,
        shading: true
      }, type, process.env.VUE_APP_BASE_MESSAGE_NOTIFY_SHOWTIME);
    },
  },
  mounted() {
    this.fetchWorkTimeSheetData()
  },
  watch: {
    '$route': 'fetchWorkTimeSheetData'
  },
};